import { put } from 'redux-saga/effects';
import { fetchConnectedAppsWithResourcesSuccess, fetchConnectedAppsWithResourcesFailure } from '../slice';
import apiClient from 'src/services/apiClient';
import { getUrl } from 'src/services/ApiService';

export function* getConnectedApps() {
    const endpoint = `/iambff/v1/connected-apps/asio_platform`;
    const url = getUrl(endpoint);

    try {
        const result = yield apiClient.get(url, {
            cache: false,
        });
        const data = result.data;
        yield put(
            fetchConnectedAppsWithResourcesSuccess({
                data,
            })
        );
    } catch (error) {
        yield put(
            fetchConnectedAppsWithResourcesFailure({
                error,
            })
        );
    }
}
